import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import Loader from "../../../shared/Loader/Loader"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { useSelector } from "react-redux"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import axios from "axios";
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import { ModalBody } from "react-bootstrap"
// import { display } from "html2canvas/dist/types/css/property-descriptors/display"

const AddNewDiagnosis = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Diagnosis')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'Diagnosis')?.IsDeleted
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        DiagnosisCodeVal: "",
    }

    let Diagnosis_Modal = {
        // PracticeID: 113,
        DiagnosisCode: null,
        Description: "",
        FullDescription: "",
        IsActive: '',
        ICD: '',
        UpdatedDate: "",
        UpdatedBy: ""
    }
    const [DiagnosisCodes, setDiagnosisCodes] = useState()
    const [DiagnosisValidationModal, setDiagnosisValidationModal] = useState(ValidationModal)
    const [DiagnosisSaveUpdateModal, setDiagnosisSaveUpdateModal] = useState({})
    const [mainDiagnosisModal, setmainDiagnosisModal] = useState(Diagnosis_Modal);
    // const [checkICD,setCheckICD]=useState({
    //     display:"",
    //     value:""
    // })
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const { isOpenDiagnosis, onClose, onDeleteDiagnosis, type, IsOpen, Diagnosisvalue, onICDSave } = { ...props }
    const [onDiagnosisSave, setOnDiagnosisSave] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [activeStatus, setActiveStatus] = useState('Active');
    const isActiveValue = activeStatus === 'Active' ? 'true' : 'false';
    const [conform, setConfrom] = useState(false)


    useEffect(() => {
        if (props.DiagnosisCode != null && !IsOpen) {
            setDiagnosisCodes(props.DiagnosisCode)
            setDel(true)
        } else {
            if (!onDiagnosisSave) {
                setDiagnosisCodes(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
    }, [])
    useEffect(() => {
        if (!isNull(DiagnosisCodes) && !IsOpen) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": DiagnosisCodes,
                "TableName": enumUtil.enumAPITableName.Diagnosis
            }).then((response) => {
                setIsLoading(false)
                setmainDiagnosisModal(response)
                setActiveStatus(response.IsActive ? 'Active' : 'InActive');
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
        setActiveStatus(activeStatus)
    }, [DiagnosisCodes])

    const checkDiagnosisCode = () => {
        return axios
            .get(`https://icd10api.com/?code=${mainDiagnosisModal.DiagnosisCode}&desc=short&r=json`)

            .then((response) => {
                if (response.data?.Valid !== undefined) {
                    return response.data.Valid;
                } else {
                    return response?.data?.Error;
                }
            })
            .catch((error) => {
                console.error("API error:", error);
                return null;
            });
    };

    useEffect(() => {
        if (IsOpen) {
            setmainDiagnosisModal({ ...mainDiagnosisModal, DiagnosisCode: Diagnosisvalue })
            setDiagnosisSaveUpdateModal({ ...DiagnosisSaveUpdateModal, DiagnosisCode: Diagnosisvalue })
        }
    }, [IsOpen]);
    // useEffect(() => {

    //     if (mainDiagnosisModal.DiagnosisCode > 2) {

    //     }


    // }, [mainDiagnosisModal.DiagnosisCode]);

    const handleDiagnosisChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainDiagnosisModal };
        let saveModal = { ...DiagnosisSaveUpdateModal }
        modal[name] = value
        setmainDiagnosisModal(modal)
        for (var property in Diagnosis_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setDiagnosisSaveUpdateModal(saveModal)
        if (name === 'display') {
            setActiveStatus(value);
        }
    }
    const DiagnosisValidation = async () => {
        let ValidationModal = {
            DiagnosisCodeVal: FormValidator(
                mainDiagnosisModal.DiagnosisCode,
                enumUtil.enumValidationType.Required,
                'Diagnosis Code',
            )
        }
        await setDiagnosisValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveDiagnosis = async () => {
        setDiagnosisCodes(mainDiagnosisModal.DiagnosisCode)
        setDiagnosisCodes(DiagnosisCodes)
        await DiagnosisValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setDiagnosisSaveUpdateModal(DiagnosisSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Diagnosis,
                ID: DiagnosisCodes,
                data: { ...DiagnosisSaveUpdateModal, IsActive: isActiveValue },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    // console.log("response", response)
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setDiagnosisCodes(response.id)
                        onICDSave?.({ 
                            display: mainDiagnosisModal?.DiagnosisCode, 
                            value: response.id + "" , 
                            Description: DiagnosisSaveUpdateModal?.Description, 
                            FullDescription: DiagnosisSaveUpdateModal?.FullDescription
                        })
                        onDeleteDiagnosis()
                        setOnDiagnosisSave(true)
                        setConfrom(false)
                        onClose();
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })


            // const diagnosisValid = await checkDiagnosisCode();
            // console.log(diagnosisValid, 'diagnosisValid');

            // if (diagnosisValid === "1" || diagnosisValid === null) {

            // }
            // else if (diagnosisValid === "0" || diagnosisValid === "Incorrect ICD Code") {
            //     NotificationHandler("Plaese select correct ", enumUtil.enumtoaster.error)
            // }
        }
        setActiveStatus('Active');
    }
    const newSave = async () => {
        const diagnosisValid = await checkDiagnosisCode();
        if (diagnosisValid === "1" || diagnosisValid === null) {
            handleSaveDiagnosis()
        }
        else if (diagnosisValid === "0" || diagnosisValid === "Incorrect ICD Code") {
            setConfrom(true)
            // NotificationHandler("Plaese select correct ", enumUtil.enumtoaster.error)
        }
    }
    const SetDiagnosisName = () => {
        if (mainDiagnosisModal.DiagnosisCode != null && mainDiagnosisModal.DiagnosisCode != "") {
            return (
                <p className="heading">{mainDiagnosisModal.DiagnosisCode}</p>
            )
        } else {
            return (
                <p className="heading">Add New Diagnosis Code</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Diagnosis} ID={DiagnosisCodes} onClose={onDeleteDiagnosis} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={DiagnosisCodes + ""} TableName={enumUtil.enumAPITableName.Diagnosis} />
    }
    const closeconfrom = () => {
        setConfrom(false)
    }
    const handleDiagnosisChangee = (e) => {
        // setClaimInfoVal(ValidationModal)
        // setIs(false)
        let { name, value } = e.target
        let modal = { ...mainDiagnosisModal }
        modal[name] = value
        setmainDiagnosisModal(modal)
        // setIcdBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": value })s
        setmainDiagnosisModal(modal)
    }
    const handleSelectDiagnosisData = (selectedData, name, type) => {
        console.log(selectedData);
        // setIs(true)
        let modal = { ...mainDiagnosisModal };
        if (type === 'client' && !isNull(selectedData)) {

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'ICD') {
                modal[name] = selectedData.Name
                mainDiagnosisModal[name] = selectedData.Name + "";
                // mainDiagnosisModal[name + 'ID'] = selectedData.value + "";
            }
        } else {
            modal[name] = ''
            mainDiagnosisModal[name] = ''
        }
        setmainDiagnosisModal(modal)
        return selectedData
    }
    const AddNewDiagnosisModalBody = () => {
        return (
            <>
                {isLoading ? <Loader /> : null}
                <div className="">
                    <div className="form-group input">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <label >Diagnosis Code<span className='req'>*</span></label>
                            {/* <div className="d-flex align-items-center gap-2">
                                <p className="text font-m">Active</p>
                                <div class="form-check form-switch radio_button mh-unset">
                                    <input class="form-check-input position-static m-0" type="checkbox" id="filesView" name="filesView" autocomplete="off"/>
                                </div>
                            </div> */}
                        </div>
                        <div className={DiagnosisValidationModal.DiagnosisCodeVal ? 'form-group input error' : 'form-group input'}>
                            <input type="text"
                                className='form-control'
                                name="DiagnosisCode"
                                id="DiagnosisCode"
                                autoComplete="off"
                                value={mainDiagnosisModal.DiagnosisCode}
                                onChange={handleDiagnosisChange}
                            />
                            {DiagnosisValidationModal.DiagnosisCodeVal}
                        </div>
                        {/* error helperText="Error Message" */}
                    </div>
                    {/* <div className='form-group input'>
                        <SuperSearch
                            ApiLink={`http://icd10api.c`}
                            method="get"
                            type={"server"}
                            id='ICD'
                            name='ICD'
                            getSelectedData={handleSelectDiagnosisData}
                            onChange={handleDiagnosisChangee}
                            searchValue={mainDiagnosisModal?.ICD}
                            tableData={[
                                { columName: 'Code', bindingValue: 'Name', },
                                { columName: 'Description', bindingValue: 'Description', },
                            ]}
                            disabled={true}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                        />


                    </div> */}
                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <input type="text"
                            className='form-control'
                            name="Description"
                            id="Description"
                            autoComplete="off"
                            value={mainDiagnosisModal.Description}
                            onChange={handleDiagnosisChange}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="FullDescription">Full Description</label>
                        <textarea type="text"
                            rows={5}
                            className='form-control'
                            name="FullDescription"
                            id="FullDescription"
                            value={mainDiagnosisModal.FullDescription}
                            onChange={handleDiagnosisChange}
                        />
                    </div>
                    <div className="d-flex gap-15">

                        <div className="ar_radio-btn d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name='display'
                                id="Active"
                                value='Active'
                                checked={activeStatus === 'Active'}
                                onChange={(e) => setActiveStatus(e.target.value)}
                            />
                            <p for="Active" className="text fs-12 ar-orange-text" >Active</p>
                        </div>
                        <div className="ar_radio-btn d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name='display'
                                id="InActive"
                                value='InActive'
                                checked={activeStatus === 'InActive'}
                                onChange={(e) => setActiveStatus(e.target.value)}
                            />
                            <p for="InActive" className="text fs-12 ar-orange-text" >In Active</p>
                        </div>
                    </div>
                </div>

                <Modal show={conform} onHide={closeconfrom} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal ar_export-excel-popup za-icd-code">
                    <Modal.Body>
                        <div className='d-flex justify-content-between align-items-center mb-10'>
                            <p className="heading fs-14 dark-clr">ICD Code Confirmatiom</p>
                            <i className='icon-x-cros fs-20 dark-clr' onClick={closeconfrom}></i>
                        </div>
                        <div className='ar-alert d-flex mb-12 gap-1 mb-0'>
                            <i className='icon-Vector13 mt-1'></i>
                            <p className='text'> This ICD code is incorrect, Do you still want to <br /> save it?</p>
                        </div>
                    </Modal.Body>

                    {/* <div className='btns-group  text-end pb-2 px-2'>
                        <button className='btn btn-gray' onClick={closeconfrom}>No</button>
                        <button className='btn btn-orange' onClick={handleSaveDiagnosis}>Yes</button>
                    </div> */}
                    <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={closeconfrom}>Cancel</button>
                        <button className='btn btn-danger px-10 h-100' onClick={handleSaveDiagnosis}>Save</button>
                    </div>
                </Modal>
            </>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <>
                    {AuditPopup}
                    <div className="pb-15 px-10">
                        {AddNewDiagnosisModalBody()}
                    </div >
                    <ModalFooter isSaved={onDiagnosisSave ? onDeleteDiagnosis : onClose} handleSave={newSave} UpdatedDate={mainDiagnosisModal.UpdatedDate} UpdatedBy={mainDiagnosisModal.UpdatedBy} ID={DiagnosisCodes} IsEditAllowed={IsEditAllowed} />
                </>
                :
                <Modal show={isOpenDiagnosis} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetDiagnosisName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onDiagnosisSave ? onDeleteDiagnosis : onClose} key={612} Name={'Location'} IsDeleteAllowed={IsDeleteAllowed} />
                        {AddNewDiagnosisModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onDiagnosisSave ? onDeleteDiagnosis : onClose} handleSave={newSave} UpdatedDate={mainDiagnosisModal.UpdatedDate} UpdatedBy={mainDiagnosisModal.UpdatedBy} ID={DiagnosisCodes} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }

        </React.Fragment>
    )
}

export default AddNewDiagnosis